// 공개 페이지 액션(rpc) — 시공사례 목록의 공개 링크 만들기·고치기·켜고 끄기.
import { rpc } from "@/api/client";

export const createPublicPage = (input: unknown) => rpc("public-page/actions/createPublicPage", input);

export const updatePublicPage = (input: unknown) => rpc("public-page/actions/updatePublicPage", input);

export const setPublicPageActive = (input: unknown) => rpc("public-page/actions/setPublicPageActive", input);
